import { jsx as _jsx } from "react/jsx-runtime";
export const VimeoEmbed = ({ contentInfo }) => {
    const url = `https://player.vimeo.com/video/${contentInfo.videoId}`;
    return (_jsx("iframe", { allow: "fullscreen; picture-in-picture", loading: "lazy", sandbox: "allow-same-origin allow-scripts", src: url, style: {
            backgroundColor: '#000',
            border: 'none',
            borderRadius: 6,
            boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.1)',
            height: 360,
            width: '100%',
        } }));
};
//# sourceMappingURL=VimeoEmbed.js.map